export default class EvoTalksConversaFilterModel {
  tipoPeriodo: string | null = null;

  dataInicio: Date | null = null;

  dataFim: Date | null = null;

  status: string | null = null;

  idFilaEvo: string | null = null;

  tipoCanal: string | null = null;

  idAtendenteGeo: number | null = null;

  numeroTelefone: string | null = null;

  protocolo: string | null = null;

  conteudo: string | null = null;

  nomeContato: string | null = null;

  tipoContato: string | null = null;

  apenasComProtocolo = false;

  cnpj: string | null = null;

  idProspect: number | null = null;
}
